import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(main)/stores/page.tsx");
